import React from 'react';
import PageContainer from "../../../../hoc/PageContainer";

const SmartPeopleLiving = () =>(
    <div>
        <PageContainer page={"smartPeopleLiving"}>
            <h1 className="AboutUsTitle">Rotary Club of Central - Smart People Living & Earth</h1>
            <div className="our-services-video-container">
                <iframe width="854" height="480" src="https://www.youtube.com/embed/8jXuG-SSuHY" frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
            </div>
            <div className="AboutUsText left">
                <p>
                    According to the World Greens Organization, Hong Kong disposes 5.3 million single use plastic bottles everyday and only 4% of those are recycled. This means 5 million bottles ending up in our sea, beaches and landfills. Rotary Club of Central is taking action to reduce this number. In March 2019, we are organizing a series of events to raise and reinforce public awareness of coastal pollution and marine conservation in Hong Kong. We are asking for your participation to join us and encourage others to commit a greener lifestyle.
                </p>

                <ol>
                    <li>
                        <b>Massive Beach Clean-up: March 3rd, 2019</b>
                        <p>
                            Together with all participating companies, we will host a massive beach cleaning in different beaches spanning across HK. Our aim is to let every participant to gain first hand experience in picking up the garbage, including sandals, toothbrushes, or plastic bottles, on the beach to acknowledge how much unnecessary wastage we produced to the environment.
                        </p>
                        <p>
                            <b>Supporting Cooperate :
                            </b>
                        </p>
                        <ol>
                            <li>Bank of China 中銀香港, 中銀人壽, 中銀保集團</li>
                            <li>Cinda International -信達國際</li>
                            <li>Chow Tai Fook Jewellery 周大福珠寶</li>
                            <li>Everbright Sun Hung Kai 光大新鴻基</li>
                            <li>FWD Life Insurance 富衛保險</li>
                            <li>Hung Hing Printing, YumMe Print 鴻興印刷</li>
                            <li>LH Group 敘福樓集團</li>
                            <li>Meinhardt Consulting Engineers 邁進顧問工程師事務所</li>
                            <li>Sanatorium & Hospital Hong Kong 養和醫院義工</li>
                            <li>Hong Kong & China Gas 煤氣公司</li>
                        </ol>
                    </li>
                    <br/>
                    <li>
                        <p><b>Photo Competition: submission digital photo between March 3rd –March 7th 2019</b></p>
                        Participating company will automatically be invited to submit any inspiring photos taken at the massive beach clean up day for a photo contest.
                    </li>
                    <br/>
                    <li>
                        <p><b>Awards Presentation & Ceremony –March 17th, 2019</b></p>
                        A closing ceremony to acknowledge participating companies; prize awards will be presented for outstanding participating companies/individuals.
                    </li>
                </ol>
            </div>

        </PageContainer>
    </div>
);

export default SmartPeopleLiving;
